<template>
  <layout>
    <div class="card text-center pt-5 h-100 d-block">
      <b-img
        style="width: 100px; height: 100px"
        :src="require('@/assets/images/fishes.png')"
        alt="logo"
        class="rotating"
      ></b-img>
      <h3 class="pb-2">{{ $t('maintenance.attention') }}</h3>
      <h4>
        {{ $t('maintenance.technical') }}
      </h4>
      <h4>
        {{ $t('maintenance.betterService') }}
      </h4>
    </div>
  </layout>
</template>

<script>
export default {
  name: 'MaintenanceOee',
  computed: {},
};
</script>
<style>
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.rotating {
  animation: spin 10s linear 0s infinite;
}
</style>
